<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="structure">
<div class="epigraph">
<p class="epf"><a class="page" id="pv"></a>A physician, in looking at his patient, ought, in imagination, to turn him inside out.</p>
<p class="ept">Anne Hope, <i>Memoir</i></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Bertoloni-Meli-0005.vue?09b95846